import { LegalDocument } from '@/components/LegalDocument'

export function TermsOfService() {
  return <LegalDocument documentKey="terms" />
}
